/* RJ October 2026 CRO draft: Gift set builder v2 (sections/rj-gift-set.liquid + snippets/rj-gift-set-card.liquid).
   Choose pieces -> customise on chips (only available combinations; ring sizes never pre-selected) -> optional gift box
   -> one /cart/add.js call -> the theme's own cart drawer is re-rendered and opened, as the theme's product form does.
   No discount, no bundle product, no app. Shopify records its standard add-to-cart events for the cart call itself;
   only custom events (gift_set_load, gift_set_add) are published here. */
(function () {
  'use strict';
  var S = window.RJ_GB_STRINGS || {};
  var currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'GBP';
  var fmt;
  try { fmt = new Intl.NumberFormat(document.documentElement.lang || 'en-GB', { style: 'currency', currency: currency }); }
  catch (e) { fmt = { format: function (n) { return n.toFixed(2); } }; }
  function money(c) { return fmt.format(c / 100); }
  function esc(t) { return String(t).replace(/[&<>"']/g, function (ch) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[ch]; }); }
  function send(name, data) {
    try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish(name, data); } catch (e) {}
    try { (window.dataLayer = window.dataLayer || []).push(Object.assign({ event: name }, data)); } catch (e) {}
  }
  /* The theme's scalloped button is a fixed-ratio shape, so the visible label stays short; the full text goes in aria-label. */
  function setBtn(btn, text, aria) {
    var sp = btn.querySelector('span[data-content]');
    if (sp) sp.setAttribute('data-content', text); else btn.textContent = text;
    btn.setAttribute('aria-label', aria || text);
  }
  var isMetal = function (n) { return /material|metal/i.test(n); };
  var isSize = function (n) { return /size/i.test(n); };

  function Builder(root) {
    var self = this;
    this.root = root;
    this.max = parseInt(root.getAttribute('data-max'), 10) || 4;
    this.threshold = parseInt(root.getAttribute('data-threshold'), 10) || 0;
    this.byoName = root.getAttribute('data-byo-name') || 'Build your own';
    this.data = {};
    Array.prototype.forEach.call(root.querySelectorAll('[data-rj-gb-piece]'), function (li) {
      try {
        var d = JSON.parse(li.querySelector('[data-rj-gb-data]').textContent);
        d.labels = labelsFor(d);
        self.data[d.h] = d;
      } catch (e) {}
    });
    try { this.sets = JSON.parse(root.querySelector('[data-rj-gb-sets]').textContent); } catch (e) { this.sets = []; }
    this.items = [];
    this.activeSet = null;
    this.cartTotal = 0;
    this.cartHasBox = false;
    this.picked = root.querySelector('[data-rj-gb-picked]');
    this.bind();
    this.render();
    this.refreshCart();
  }

  /* Short labels for long metal values ("18k gold plated stainless steel" -> Gold) when unambiguous for that product. */
  function labelsFor(d) {
    var groups = d.o.map(function (name, j) {
      var vals = []; d.v.forEach(function (v) { if (vals.indexOf(v.o[j]) === -1) vals.push(v.o[j]); });
      var map = {};
      if (isMetal(name)) {
        var short = vals.map(function (x) { var l = x.toLowerCase(); return l.indexOf('gold') !== -1 ? 'Gold' : (l.indexOf('silver') !== -1 || l.indexOf('stainless') !== -1 || l.indexOf('titanium') !== -1) ? 'Silver' : null; });
        var ok = short.every(function (x, i) { return x && short.indexOf(x) === i; });
        vals.forEach(function (x, i) { map[x] = ok ? short[i] : x; });
      } else {
        vals.forEach(function (x) { map[x] = x.charAt(0).toUpperCase() + x.slice(1); });
      }
      return { name: name, values: vals, label: map };
    });
    /* If two options always move together (e.g. material and colour that mirror each other), show only the one with
       shorter labels; the hidden one follows automatically. Sizes are never hidden. */
    groups.forEach(function (g, j) {
      if (g.values.length < 2 || isSize(g.name)) return;
      groups.forEach(function (h, k) {
        if (k === j || g.hidden || h.hidden || h.values.length !== g.values.length) return;
        var a = {}, b = {}, ok = true;
        d.v.forEach(function (v) {
          var x = v.o[j], y = v.o[k];
          if ((a[x] && a[x] !== y) || (b[y] && b[y] !== x)) ok = false;
          a[x] = y; b[y] = x;
        });
        if (!ok) return;
        var len = function (gr) { return gr.values.reduce(function (n, x) { return n + String(gr.label[x]).length; }, 0); };
        if (len(g) > len(h) || (len(g) === len(h) && j > k)) g.hidden = true;
      });
    });
    return groups;
  }

  Builder.prototype.bind = function () {
    var self = this, root = this.root;
    root.addEventListener('click', function (e) {
      var t;
      if ((t = e.target.closest('[data-rj-gb-toggle]'))) { self.toggle(t.closest('[data-rj-gb-piece]').getAttribute('data-rj-gb-piece')); return; }
      if ((t = e.target.closest('[data-rj-gb-cat]'))) { self.filter(t.getAttribute('data-rj-gb-cat')); return; }
      if ((t = e.target.closest('[data-rj-gb-load]'))) { self.loadSet(t.getAttribute('data-rj-gb-load')); return; }
      if ((t = e.target.closest('[data-rj-gb-chip]'))) {
        if (t.disabled) return;
        self.choose(parseInt(t.getAttribute('data-i'), 10), parseInt(t.getAttribute('data-j'), 10), t.getAttribute('data-value'));
        return;
      }
      if ((t = e.target.closest('[data-rj-gb-remove]'))) { self.remove(parseInt(t.getAttribute('data-i'), 10)); return; }
      if ((t = e.target.closest('[data-rj-gb-swap]'))) { self.swap(parseInt(t.getAttribute('data-i'), 10)); return; }
      if (e.target.closest('[data-rj-gb-add]')) { self.add(); return; }
    });
    root.addEventListener('change', function (e) { if (e.target.matches('[data-rj-gb-box]')) self.renderBar(); });
    document.addEventListener('cart:updated', function () { self.refreshCart(); });
  };

  /* ---------- selection logic ---------- */
  Builder.prototype.newItem = function (h, metalPref) {
    var d = this.data[h];
    var avail = d.v.filter(function (v) { return v.a; });
    var start = avail[0] || d.v[0];
    if (metalPref && metalPref !== 'any') {
      var mj = d.o.findIndex(isMetal);
      if (mj > -1) {
        var hit = avail.filter(function (v) { return v.o[mj].toLowerCase().indexOf(metalPref === 'gold' ? 'gold' : 'stainless') !== -1 && (metalPref === 'gold' || v.o[mj].toLowerCase().indexOf('gold') === -1); })[0];
        if (hit) start = hit;
      }
    }
    var sel = d.o.map(function (name, j) {
      var vals = d.labels[j].values;
      if (isSize(name) && vals.length > 1) return '';
      return start ? start.o[j] : vals[0];
    });
    return { h: h, sel: sel };
  };
  Builder.prototype.variantFor = function (item) {
    var d = this.data[item.h];
    if (item.sel.some(function (x) { return x === ''; })) return null;
    for (var i = 0; i < d.v.length; i++) {
      var v = d.v[i], ok = true;
      for (var j = 0; j < item.sel.length; j++) { if (v.o[j] !== item.sel[j]) { ok = false; break; } }
      if (ok) return v;
    }
    return null;
  };
  Builder.prototype.possible = function (item, j, value) {
    var d = this.data[item.h];
    return d.v.some(function (v) {
      if (!v.a || v.o[j] !== value) return false;
      for (var k = 0; k < item.sel.length; k++) { if (k !== j && item.sel[k] !== '' && v.o[k] !== item.sel[k]) return false; }
      return true;
    });
  };
  Builder.prototype.choose = function (i, j, value) {
    var item = this.items[i], d = this.data[item.h];
    item.sel[j] = value;
    /* Keep the rest valid: re-pick any other choice that no longer has an available variant (sizes are cleared, never guessed). */
    for (var k = 0; k < item.sel.length; k++) {
      if (k === j || item.sel[k] === '') continue;
      if (!this.possible(item, k, item.sel[k])) {
        if (isSize(d.o[k]) && d.labels[k].values.length > 1) { item.sel[k] = ''; continue; }
        var fit = d.v.filter(function (v) { return v.a && v.o[j] === value; })[0];
        item.sel[k] = fit ? fit.o[k] : item.sel[k];
      }
    }
    this.error('');
    this.render();
  };
  Builder.prototype.toggle = function (h) {
    var idx = this.items.findIndex(function (x) { return x.h === h; });
    if (idx > -1) { this.remove(idx); return; }
    if (this.items.length >= this.max) { this.error(S.max || ''); return; }
    this.items.push(this.newItem(h, this.items.length ? this.metalOf(this.items[0]) : 'any'));
    this.markCustomised();
    this.render();
  };
  Builder.prototype.metalOf = function (item) {
    var d = this.data[item.h], mj = d.o.findIndex(isMetal);
    if (mj < 0) return 'any';
    var l = (item.sel[mj] || '').toLowerCase();
    return l.indexOf('gold') !== -1 ? 'gold' : (l ? 'silver' : 'any');
  };
  Builder.prototype.remove = function (i) { this.items.splice(i, 1); this.markCustomised(); this.render(); };
  Builder.prototype.swap = function (i) {
    var cat = this.data[this.items[i].h].c;
    this.remove(i);
    this.filter(cat === 'Other' ? 'all' : cat);
    var step = this.root.querySelector('[data-rj-gb-step="1"]');
    if (step) step.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };
  Builder.prototype.markCustomised = function () { if (this.activeSet) this.activeSet.changed = true; this.error(''); };
  Builder.prototype.loadSet = function (id) {
    var set = this.sets.filter(function (x) { return x.id === id; })[0];
    if (!set) return;
    var self = this;
    this.items = set.items.filter(function (h) { return self.data[h]; }).slice(0, this.max).map(function (h) { return self.newItem(h, set.metal); });
    this.activeSet = { name: set.name, changed: false };
    this.render();
    var live = this.root.querySelector('[data-rj-gb-picked]');
    var step2 = this.root.querySelector('[data-rj-gb-step="2"]');
    if (step2) step2.scrollIntoView({ behavior: 'smooth', block: 'start' });
    this.say((S.loaded || '').replace('[set]', set.name));
    send('gift_set_load', { set: set.name });
    if (live) live.focus && live.focus();
  };
  Builder.prototype.filter = function (cat) {
    Array.prototype.forEach.call(this.root.querySelectorAll('[data-rj-gb-cat]'), function (b) {
      var on = b.getAttribute('data-rj-gb-cat') === cat; b.classList.toggle('is-active', on); b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    Array.prototype.forEach.call(this.root.querySelectorAll('[data-rj-gb-piece]'), function (li) {
      li.hidden = !(cat === 'all' || li.getAttribute('data-cat') === cat);
    });
    var pool = this.root.querySelector('[data-rj-gb-pool]'); if (pool) pool.scrollLeft = 0;
  };

  /* ---------- rendering ---------- */
  Builder.prototype.render = function () {
    var self = this;
    Array.prototype.forEach.call(this.root.querySelectorAll('[data-rj-gb-piece]'), function (li) {
      var h = li.getAttribute('data-rj-gb-piece'), on = self.items.some(function (x) { return x.h === h; });
      li.classList.toggle('is-selected', on);
      var btn = li.querySelector('[data-rj-gb-toggle]'); btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      var st = li.querySelector('[data-rj-gb-state]'); if (st) st.textContent = (on ? (S.remove || 'Remove') + ' ' : 'Add ') + (self.data[h] ? self.data[h].t : '');
    });
    var html = this.items.map(function (item, i) {
      var d = self.data[item.h], v = self.variantFor(item);
      var img = (v && v.img) || d.img;
      var price = v ? v.p : Math.min.apply(null, d.v.filter(function (x) { return x.a; }).map(function (x) { return x.p; }));
      var save = v && v.cp > v.p ? (S.saving || '').replace('[amount]', money(v.cp - v.p)) : '';
      var groups = d.labels.map(function (g, j) {
        if (g.values.length < 2 || g.hidden) return '';
        var title = isSize(g.name) && d.c === 'Rings' ? 'Ring size (US)' : (isMetal(g.name) ? 'Metal' : /^colou?r$/i.test(g.name) ? 'Colour' : g.name.charAt(0).toUpperCase() + g.name.slice(1));
        var chips = g.values.map(function (val) {
          var ok = self.possible(item, j, val), on = item.sel[j] === val;
          return '<button type="button" class="rj-gb__chip' + (on ? ' is-on' : '') + '" data-rj-gb-chip data-i="' + i + '" data-j="' + j + '" data-value="' + esc(val) + '" aria-pressed="' + on + '"' + (ok ? '' : ' disabled aria-disabled="true" title="' + esc(S.soldOut || '') + '"') + '>' + esc(g.label[val]) + '</button>';
        }).join('');
        var missing = item.sel[j] === '';
        return '<div class="rj-gb__group' + (missing ? ' is-missing' : '') + '" role="group" aria-label="' + esc(title + ' – ' + d.t) + '"><span class="rj-gb__group-label">' + esc(title) + (missing ? ' <em>' + esc(S.choose || 'Choose') + '</em>' : '') + '</span><div class="rj-gb__chips">' + chips + '</div></div>';
      }).join('');
      return '<li class="rj-gb__row">' +
        '<div class="rj-gb__row-top">' +
          (img ? '<img class="rj-gb__row-img" src="' + esc(img) + '" alt="" width="64" height="64">' : '<span class="rj-gb__row-img"></span>') +
          '<div class="rj-gb__row-info"><a class="rj-gb__row-name" href="' + esc(d.u) + '">' + esc(d.t) + '</a>' +
          '<p class="rj-gb__row-price">' + money(price) + (save ? ' <span class="rj-gb__row-save">' + esc(save) + '</span>' : '') + '</p></div>' +
          '<div class="rj-gb__row-actions"><button type="button" class="rj-gb__link" data-rj-gb-swap data-i="' + i + '">' + esc(S.swap || 'Swap') + '</button>' +
          '<button type="button" class="rj-gb__x" data-rj-gb-remove data-i="' + i + '" aria-label="' + esc((S.remove || 'Remove') + ' ' + d.t) + '">×</button></div>' +
        '</div>' + groups + '</li>';
    }).join('');
    this.picked.innerHTML = html;
    var empty = this.root.querySelector('[data-rj-gb-empty]'); if (empty) empty.hidden = this.items.length > 0;
    this.renderBar();
  };
  Builder.prototype.renderBar = function () {
    var self = this, sub = 0, missing = [];
    this.items.forEach(function (item) {
      var d = self.data[item.h], v = self.variantFor(item);
      if (v) sub += v.p; else { sub += Math.min.apply(null, d.v.filter(function (x) { return x.a; }).map(function (x) { return x.p; })); missing.push(d.t); }
    });
    var box = this.root.querySelector('[data-rj-gb-box]:checked');
    var boxPrice = box ? parseInt(box.getAttribute('data-price'), 10) || 0 : 0;
    var total = sub + (this.items.length ? boxPrice : 0);
    this.total = total;
    var n = this.items.length;
    this.root.querySelector('[data-rj-gb-count]').textContent = n === 1 ? (S.piece || '1 piece') : (S.pieces || '[count] pieces').replace('[count]', n);
    this.root.querySelector('[data-rj-gb-total]').textContent = money(total);
    var subEl = this.root.querySelector('[data-rj-gb-sub]');
    if (missing.length) subEl.textContent = (S.chooseSize || '').replace('[title]', missing[0]);
    else if (n && this.threshold > 0 && this.cartDiscounted) {
      subEl.textContent = (S.shipRule || 'Free UK Tracked 48 over [amount] after discounts; your bag shows the final total.').replace('[amount]', money(this.threshold));
    } else if (n && this.threshold > 0) {
      var basis = total + this.cartTotal;
      subEl.textContent = basis >= this.threshold ? (S.shipFree || '') : (S.shipAway || '').replace('[amount]', money(this.threshold - basis));
    } else subEl.textContent = '';
    var add = this.root.querySelector('[data-rj-gb-add]');
    if (!add.classList.contains('is-loading')) { add.disabled = n === 0; setBtn(add, S.add || 'Add to bag', (S.add || 'Add to bag') + (n ? ' · ' + money(total) : '')); }
    var dup = this.root.querySelector('[data-rj-gb-box-dup]'); if (dup) dup.hidden = !(this.cartHasBox && boxPrice > 0);
    var big = this.root.querySelector('[data-rj-gb-box-size]');
    if (big) big.hidden = !(n >= 4 && box && /standard/i.test(box.getAttribute('data-box-title') || ''));
    this.root.classList.toggle('has-items', n > 0);
  };
  Builder.prototype.error = function (t) {
    var el = this.root.querySelector('[data-rj-gb-error]'); if (!el) return;
    el.textContent = t || ''; el.hidden = !t;
  };
  Builder.prototype.say = function (t) {
    var el = this.root.querySelector('[data-rj-gb-sub]'); if (el && t) el.textContent = t;
  };

  /* ---------- cart ---------- */
  Builder.prototype.refreshCart = function () {
    var self = this;
    return fetch(((window.Shopify && Shopify.routes && Shopify.routes.root) || '/') + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        self.cartTotal = c.total_price || 0;
        /* With a discount code on the cart, the free-delivery threshold is measured after discounts, which the builder
           cannot know in advance, so it states the rule instead of a promise. */
        self.cartDiscounted = (c.discount_codes || []).length > 0 || (c.total_discount || 0) > 0;
        var ids = []; Array.prototype.forEach.call(self.root.querySelectorAll('[data-rj-gb-box]'), function (b) { if (b.value) ids.push(parseInt(b.value, 10)); });
        self.cartHasBox = (c.items || []).some(function (it) { return ids.indexOf(it.variant_id) !== -1; });
        self.renderBar();
      }).catch(function () {});
  };
  Builder.prototype.add = function () {
    var self = this;
    if (!this.items.length) return;
    var lines = [], firstMissing = -1;
    this.items.forEach(function (item, i) {
      var v = self.variantFor(item);
      if (!v || !v.a) { if (firstMissing < 0) firstMissing = i; return; }
      lines.push({ id: v.id, quantity: 1, properties: { _gift_set: self.setName() } });
    });
    if (firstMissing > -1) {
      var d = this.data[this.items[firstMissing].h];
      this.error((S.chooseSize || '').replace('[title]', d.t));
      var g = this.picked.querySelectorAll('.rj-gb__row')[firstMissing];
      if (g) { g.scrollIntoView({ behavior: 'smooth', block: 'center' }); var c = g.querySelector('.is-missing .rj-gb__chip:not([disabled])'); if (c) c.focus({ preventScroll: true }); }
      return;
    }
    var box = this.root.querySelector('[data-rj-gb-box]:checked');
    if (box && box.value) lines.push({ id: parseInt(box.value, 10), quantity: 1, properties: { _gift_set: self.setName() } });
    var btn = this.root.querySelector('[data-rj-gb-add]');
    btn.classList.add('is-loading'); btn.disabled = true; setBtn(btn, S.adding || 'Adding…');
    var drawer = document.getElementById('Cart-Drawer');
    var url = ((window.theme && theme.routes && theme.routes.cart_add_url) || '/cart/add') + '.js';
    fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: lines, sections: drawer ? 'cart-drawer,cart-bubble' : '', sections_url: window.location.pathname })
    }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
      .then(function (res) {
        if (!res.ok || res.body.status) { self.error(res.body.description || res.body.message || S.error || ''); return; }
        send('gift_set_add', { set: self.setName(), pieces: self.items.length, gift_box: !!(box && box.value), value: self.total / 100, currency: currency });
        setBtn(btn, S.added || 'Added');
        if (!openDrawer(res.body)) { window.location.href = (window.theme && theme.routes && theme.routes.cart_url) || '/cart'; return; }
        self.refreshCart();
      })
      .catch(function () { self.error(S.error || ''); })
      .finally(function () { setTimeout(function () { btn.classList.remove('is-loading'); self.renderBar(); }, 1200); });
  };
  Builder.prototype.setName = function () {
    if (this.activeSet) return this.activeSet.name + (this.activeSet.changed ? ' (customised)' : '');
    return this.byoName;
  };

  /* Same steps as the theme's ProductForm.renderContents(): swap in the fresh drawer and bubble, then open the drawer. */
  function openDrawer(body) {
    var drawer = document.getElementById('Cart-Drawer');
    if (!drawer || !body.sections || !body.sections['cart-drawer']) return false;
    try {
      var parse = function (html, sel) { var d = new DOMParser().parseFromString(html, 'text/html').querySelector(sel); return d ? d.innerHTML : null; };
      var target = drawer.querySelector('.cart-drawer') || drawer;
      var html = parse(body.sections['cart-drawer'], '.cart-drawer');
      if (html === null) return false;
      target.innerHTML = html;
      ['removeProductEvent', 'notesToggle', 'updateFreeShipping'].forEach(function (m) { if (typeof target[m] === 'function') target[m](); });
      var bubble = document.getElementById('cart-drawer-toggle');
      if (bubble && body.sections['cart-bubble']) {
        var bT = bubble.querySelector('.thb-item-count') || bubble, bH = parse(body.sections['cart-bubble'], '.thb-item-count');
        if (bH !== null) bT.innerHTML = bH;
      }
      var search = document.getElementById('Search-Drawer'); if (search) search.classList.remove('active');
      document.body.classList.add('open-cc');
      drawer.classList.add('active');
      if (typeof window.dispatchCustomEvent === 'function') {
        window.dispatchCustomEvent('cart-drawer:open');
        window.dispatchCustomEvent('cart:item-added', { product: body.items ? body.items[0] : body });
      }
      return true;
    } catch (e) { return false; }
  }

  function init() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-rj-gb]'), function (el) {
      if (el.__rjgb) return; el.__rjgb = new Builder(el);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  /* Back/forward cache: the theme's header count can be stale when a page is restored, so refresh it and the builder. */
  window.addEventListener('pageshow', function (e) {
    if (!e.persisted) return;
    fetch(((window.Shopify && Shopify.routes && Shopify.routes.root) || '/') + '?sections=cart-bubble').then(function (r) { return r.json(); }).then(function (j) {
      var b = document.querySelector('#cart-drawer-toggle .thb-item-count'); if (!b || !j['cart-bubble']) return;
      var d = new DOMParser().parseFromString(j['cart-bubble'], 'text/html').querySelector('.thb-item-count'); if (d) b.innerHTML = d.innerHTML;
    }).catch(function () {});
    Array.prototype.forEach.call(document.querySelectorAll('[data-rj-gb]'), function (el) { if (el.__rjgb) el.__rjgb.refreshCart(); });
  });
})();
